import type { ReportJobBatchEntry } from "../../../client/types.gen";

export type SindriRunStatus =
  | "in_progress"
  | "success"
  | "failure"
  | "superseded";

/** A replacement-cost run's status. A newer run cancels an unfinished older
 * one, whose batch then reads as a failure; it is reported as superseded. */
export const sindriRunStatus = (job: ReportJobBatchEntry): SindriRunStatus => {
  if (job.jobs.some((task) => task.status === "cancelled")) return "superseded";
  if (job.outcome === "success") return "success";
  if (job.outcome === "failure") return "failure";
  return "in_progress";
};

export const SINDRI_RUN_STATUS_LABELS: Record<SindriRunStatus, string> = {
  in_progress: "In Progress",
  success: "Success",
  failure: "Failed",
  superseded: "Superseded",
};

export const SINDRI_RUN_STATUS_SEVERITIES: Record<
  SindriRunStatus,
  "success" | "info" | "danger" | null
> = {
  in_progress: "info",
  success: "success",
  failure: "danger",
  // This PrimeReact Tag has no neutral severity; null gives its plain style.
  superseded: null,
};
